import { render } from "./SearchListing.vue?vue&type=template&id=2ba5a660&scoped=true"
import script from "./SearchListing.vue?vue&type=script&lang=js"
export * from "./SearchListing.vue?vue&type=script&lang=js"

import "./SearchListing.vue?vue&type=style&index=0&id=2ba5a660&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2ba5a660"

export default script